import { render, staticRenderFns } from "./service-card.vue?vue&type=template&id=bafca59e&scoped=true&"
import script from "./service-card.vue?vue&type=script&lang=js&"
export * from "./service-card.vue?vue&type=script&lang=js&"
import style0 from "./service-card.vue?vue&type=style&index=0&id=bafca59e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bafca59e",
  null
  
)

export default component.exports